function StatusIconController() {
  const ctrl = this;
}

angular.module('configuration-management.module').controller('StatusIconController', StatusIconController);
